import { Link } from '@kidslabs/mario-nextjs-react-ui-core';
import { Routes } from '@/config/routes';
import { UserAvatarIcon } from '@/_application/icons/user-avatar';

export function GuestInfo() {
    return (
        <div className="mb-3 rounded-[10px] bg-white px-2.5 py-3">
            <div className="mb-2.5 flex items-center gap-1">
                <UserAvatarIcon className="h-8.5 w-8.5 shrink-0" />
                <div className="flex-1" style={{lineHeight: 'normal'}}>
                    <p className="text-[10px] text-KPZ_text_1st">
                        Chào <span className="font-bold">Ba/Mẹ</span> đến với{' '}
                        <span className="font-bold text-primary">KidsPlaza</span>
                    </p>
                    <p className="text-[8px] text-KPZ_text_1st">(Vui lòng đăng nhập để kiểm tra điểm KiCoin)</p>
                </div>
            </div>

            <div className="flex items-center justify-between gap-2">
                <Link
                    href={Routes.auth}
                    aria-label="Đăng ký với tư cách khách"
                    className="h-fit! w-fit! flex-1! rounded-[56px] border! border-primary! bg-white px-0! py-0.5! text-xs! font-bold! text-primary! transition-colors hover:bg-primary hover:text-white!">
                    Đăng ký
                </Link>

                <Link
                    href={Routes.auth}
                    aria-label="Đăng nhập với tư cách khách"
                    className="h-fit! w-fit! flex-1! rounded-full border! border-primary! bg-white px-0! py-0.5! text-xs! font-bold! text-primary! transition-colors hover:bg-primary hover:text-white!">
                    Đăng nhập
                </Link>
            </div>
        </div>
    );
}
